const ImageFooter = "?x-oss-process=image/resize,m_fill,w_100,h_100,limit_0/auto-orient,1/quality,q_90";

const Icon = {
    // 后缀
    ImageFooter,
    // 进球
    GOAL: 'https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/jinqiu.png' + ImageFooter,
    // 点球
    PENALTY_KICK: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/dianqiu.png" + ImageFooter,
    // 点球未进
    PENALTY_NOT_SCORED: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/dianqiubujin.png?" + ImageFooter,
    // 乌龙球
    OWN_GOAL: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/wulong.png" + ImageFooter,
    // 助攻
    ASSIST: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/assist.png" + ImageFooter,
    // 红牌
    RED_CARD: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/redCard.png" + ImageFooter,
    // 黄牌
    YELLOW_CARD: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/yellowCard.png" + ImageFooter,
    // 上场
    UP_ICON: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/upIcons.png" + ImageFooter,
    // 下场
    DOWN_ICON: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/downIcons.png" + ImageFooter,
    //上下场
    UP_AND_DOWN_ICON: 'https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/changePeople.png' + ImageFooter,
    //科朋LOGO
    KEPENG_LOGO: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/kplogo.png" + ImageFooter,
    //次要logo
    ICON_MINOR: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/icon_ciyao.png" + ImageFooter,
    //主要logo
    ICON_MAIN: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/icon_main.png" + ImageFooter,
    //生日Icon
    BIRTHDAY: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/birthday.png" + ImageFooter,
    //一百场倍数
    ONE_HUNTRED: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/100Plus.png" + ImageFooter,
    //连败
    ICON_FAIL: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/icon_bai.png" + ImageFooter,
    //连胜
    ICON_SUCCESS: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/icon_sheng.png" + ImageFooter,
    //视频播放
    VIDEO_PALY: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/videoPlay.png" + ImageFooter,
    //添加视频
    VIDEO_ADD: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/videoAdd.png" + ImageFooter,
    //球衣
    JERSEY: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/jersey.png" + ImageFooter,
    //队长
    CAPTAIN: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/duizhang.png" + ImageFooter,
    //副队长
    SUB_CAPTAIN: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/fuduizhang.png" + ImageFooter,
    //聚餐标志
    DINNER_ICON: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/jucan.png" + ImageFooter,
    //A级
    A_LEVEL: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/alevel.png" + ImageFooter,
    //S级
    S_LEVEL: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/slevel.png" + ImageFooter,
    //B级
    B_LEVEL: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/blevel.png" + ImageFooter,
    //C级
    C_LEVEL: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/clevel.png" + ImageFooter,
    //D级
    D_LEVEL: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/dlevel.png" + ImageFooter,
    //since2010
    SINCE_2010: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/since2010.png" + ImageFooter,
    //受伤
    SHOUSHANG: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/shoushang.png" + ImageFooter,
    //生日快乐
    SHENGRIKUAILE: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/shengrikuaile.png",
    //15th
    FIFTEEN_TH: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/15th.png",
    //手抛球
    SHOUSHANG_SHENGRIKUAILE: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/shoupaoqiu.png",
    //开大脚
    KAIDAJIAO: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/kaidajiao.png",
    //折返跑
    ZHEFANPAO: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/paobu.png",
    //状态审核中：
    STATUS_AUDIT: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/status_audit.png",
    //状态正常
    STATUS_NORMAL: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/status_normal.png",
    //状态驳回
    STATUS_REJECT: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/status_reject.png",
    //绿队默认头像
    GREEN_DEFAILT_AVATAR: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/greenDefultImg.jpg",
    //红队默认头像
    RED_DEFAILT_AVATAR: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/redDefultImg.jpg",
    //裁判默认头像
    REFEREE_DEFALT_AVATAR: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/64e1481d28394d69.jpg",
    //紫色衣服默认头像
    PURPLE_DEFAILT_AVATAR: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/purple_img.png",
    //裁判哨子
    CAIPAN_SHAOZI: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/caipanshaozi.png" + ImageFooter,
    //运动战进球
    YUNDONGZHAN: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/yundongzhan.png" + ImageFooter,
    //定位球
    DINGWEIQIU: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/dingweiqiu.png" + ImageFooter,
    // 足球场地背景，统一从这里维护，避免页面里散落旧背景地址
    FOOTBALL_FIELD_BACKGROUND: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/hxkpbeijingtu-new.png",

    WAIYUAN: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/waiyuan.png" + ImageFooter,

    CHANGCI: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/changci.png" + ImageFooter,

    JIFENXINGBIAO: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/jifenxingbiao.png" + ImageFooter,

    JINQIUSHU: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/jinqiushu.png" + ImageFooter,

    VS_LOGO: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/vs.png" + ImageFooter,

    FIRE_FAIL: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/fireFail.gif" + ImageFooter,

    FIRE_WIN: "https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/fireWin.gif" + ImageFooter,

    LEI_TAI:"https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/leitai.png" + ImageFooter

};

export default Icon;
